// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1zB03","itemTitle":"ClientEmergencyInfo_itemTitle__2XlOT","itemText":"ClientEmergencyInfo_itemText__3KMRJ"};